import React from 'react';
import { Box, Heading } from '@hover/blueprint';

interface IComparisonTableProps {
  heading: string;
  table: React.ReactNode;
}

const ComparisonTable: React.FC<IComparisonTableProps> = ({
  heading,
  table,
}) => (
  <Box
    py={16}
    maxW={{ base: '100%', desktop: '6xl' }}
    flexDir="column"
    textAlign="center"
    alignItems="center"
    px={{ base: 500, desktop: '56px' }}
  >
    <Heading
      size={600}
      sx={{ mb: 6 }}
      as="h2"
      fontWeight={600}
      maxW={{ base: '100%', desktop: '4xl' }}
    >
      {heading}
    </Heading>
    <Box>{table}</Box>
  </Box>
);

export default ComparisonTable;
